const RouteURL = {
  HOMEPAGE: '/',
}

export default RouteURL
